import React from 'react';
import './Badge.less';

/**
 * Badge — small status chip with a tone that matches design tokens.
 * tone ∈ 'neutral' | 'success' | 'info' | 'warning' | 'danger'
 */
function Badge({ tone = 'neutral', children, className = '' }) {
  return (
    <span className={`gc-badge gc-badge-${tone} ${className}`.trim()}>
      <span className="gc-badge-dot" aria-hidden="true" />
      <span>{children}</span>
    </span>
  );
}

export default Badge;
